module.exports = __webpack_public_path__ + "img/site-survey.fe55f73b.webp";